import type { SiteThemeId } from "../../themes";

/**
 * Colours a button can take, each drawn in ButtonBlock.css as
 * `.site-button[data-tone="<id>"]` (and `.button-swatch-<id>` in menus).
 * Accent, Ink and Soft follow the theme; the rest are Hazumu colours, each
 * with the text colour that reads on it.
 */
export const BUTTON_COLOURS = {
  accent: "Accent",
  ink: "Ink",
  soft: "Soft",
  terracotta: "Terracotta",
  clay: "Clay",
  forest: "Forest",
  sage: "Sage",
  gold: "Gold",
  blush: "Blush",
  stone: "Stone",
  white: "White",
  "sage-pale": "Pale sage",
} as const;
export type ButtonColour = keyof typeof BUTTON_COLOURS;

/** The colours offered with each theme: the theme's own three, then a palette that pairs with it. */
export const THEME_BUTTON_COLOURS: Record<SiteThemeId, ButtonColour[]> = {
  // Each theme's default accent isn't repeated in its palette.
  warm: ["accent", "ink", "soft", "clay", "forest", "sage", "gold", "blush"],
  gallery: ["accent", "ink", "soft", "terracotta", "forest", "sage", "gold", "stone", "blush"],
  night: ["accent", "ink", "soft", "clay", "sage", "white", "sage-pale", "terracotta"],
};
